module.exports = __webpack_public_path__ + "img/yx3.378d76e9.jpg";